import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import Dumbo from '../Dumbo';
import PremiumIcon from '../Helper/PremiumIcon';
import s from './DumboWithIcon.scss';
// The icon is shown on premium deviations
export const DumboWithIcon = (_param)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement(Dumbo, props), /*#__PURE__*/ React.createElement(PremiumIcon, {
        className: s['icon'],
        premiumFolderData: props.deviation.premiumFolderData,
        tooltipClassName: s['tooltip']
    }));
};
DumboWithIcon.displayName = 'DumboWithIcon';
export default DumboWithIcon;
